"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginTwoFactorAuthForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var util_1 = require("../util");
var sentry_1 = require("../sentry");
var descriptionTextStyle = {
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    lineHeight: "200%",
    fontSize: "smaller",
};
var cautionTextStyle = __assign(__assign({}, descriptionTextStyle), { color: "#900" });
var cautionTitleTextStyle = __assign(__assign({}, cautionTextStyle), { fontWeight: "bold" });
exports.LoginTwoFactorAuthForm = (0, react_router_1.withRouter)(function LoginForm(state) {
    var _a = React.useState(""), token = _a[0], setToken = _a[1];
    var _b = React.useState(false), logining = _b[0], setLogining = _b[1];
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, { loading: logining, onSubmit: function (e) {
            e.preventDefault();
            tryLogin2FA(state, token, setLogining);
            return false;
        }, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Segment, { children: i18n_1.default.twoFactorAuthDescription }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Group, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, { inline: true, width: "6", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { label: i18n_1.default.twoFactorAuthCode, value: token, onChange: function (e) { return setToken(e.target.value); }, placeholder: "000000" }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Button, { id: "loginSubmit", primary: true, type: "submit", width: "3", children: i18n_1.default.login })] }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", onClick: function () { return (state.location.state ? state.history.goBack() : state.history.push("/")); }, children: i18n_1.default.back }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Segment, { children: (0, jsx_runtime_1.jsx)("div", { style: descriptionTextStyle, children: i18n_1.default.loginNotice }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, { children: [(0, jsx_runtime_1.jsx)("div", { style: cautionTitleTextStyle, children: i18n_1.default.loginCautionTitle }), (0, jsx_runtime_1.jsx)("div", { style: cautionTextStyle, children: i18n_1.default.loginCaution })] })] }));
});
// const toBase64 = (str: string) => btoa(unescape(encodeURIComponent(str)));
var tryLogin2FA = function (state, code, setLogining) { return __awaiter(void 0, void 0, void 0, function () {
    var result, user, profile, worlds, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                setLogining(true);
                return [4 /*yield*/, (0, api_1.login2FA)(code)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, api_1.login)()];
            case 2:
                result = _a.sent();
                if ("requiresTwoFactorAuth" in result) {
                    setLogining(false);
                    alert("".concat(i18n_1.default.loginfailed));
                    return [2 /*return*/];
                }
                user = result.user;
                return [4 /*yield*/, (0, api_1.fetchProfile)(result.user.id)];
            case 3:
                profile = _a.sent();
                state.setSelfUser(__assign(__assign({}, user), { profile: profile || { id: user.id, tags: [], privateTags: [] }, locationInfo: (0, util_1.parseUserLocation)(user) }));
                state.setLogined(true);
                return [4 /*yield*/, (0, api_1.fetchMyWorlds)()];
            case 4:
                worlds = _a.sent();
                state.addWorlds((0, util_1.toIdHash)(worlds));
                return [3 /*break*/, 6];
            case 5:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1);
                state.incrementErrorCount();
                alert("".concat(i18n_1.default.loginfailed, "\n").concat(e_1));
                setLogining(false);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
